var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 39.4,
    height: 39.4,
    rx: 19.7,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 39.4,
    height: 39.4,
    rx: 19.7,
    stroke: "#E5E5E5",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3892 13L23.3892 15.1667",
    stroke: "#842234",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1667 13L16.1667 17.3333",
    stroke: "#842234",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1667 23.8335L16.1667 26.0002",
    stroke: "#842234",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3892 21.6665L23.3892 25.9998",
    stroke: "#842234",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.389 15.1665C24.062 15.1665 24.3985 15.1665 24.664 15.2765C25.0179 15.4231 25.2991 15.7043 25.4457 16.0582C25.5557 16.3236 25.5557 16.6601 25.5557 17.3332C25.5557 18.0062 25.5557 18.3427 25.4457 18.6082C25.2991 18.9621 25.0179 19.2433 24.664 19.3899C24.3985 19.4998 24.062 19.4998 23.389 19.4998C22.716 19.4998 22.3795 19.4998 22.114 19.3899C21.7601 19.2433 21.4789 18.9621 21.3323 18.6082C21.2223 18.3427 21.2223 18.0062 21.2223 17.3332C21.2223 16.6601 21.2223 16.3236 21.3323 16.0582C21.4789 15.7043 21.7601 15.4231 22.114 15.2765C22.3795 15.1665 22.716 15.1665 23.389 15.1665Z",
    stroke: "#842234",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1668 19.5C16.8399 19.5 17.1764 19.5 17.4418 19.6099C17.7957 19.7565 18.077 20.0378 18.2236 20.3917C18.3335 20.6571 18.3335 20.9936 18.3335 21.6667C18.3335 22.3397 18.3335 22.6762 18.2236 22.9417C18.077 23.2956 17.7957 23.5768 17.4418 23.7234C17.1764 23.8333 16.8399 23.8333 16.1668 23.8333C15.4938 23.8333 15.1573 23.8333 14.8918 23.7234C14.5379 23.5768 14.2567 23.2956 14.1101 22.9417C14.0002 22.6762 14.0002 22.3397 14.0002 21.6667C14.0002 20.9936 14.0002 20.6571 14.1101 20.3917C14.2567 20.0378 14.5379 19.7565 14.8918 19.6099C15.1573 19.5 15.4938 19.5 16.1668 19.5Z",
    stroke: "#842234",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.0c282c1db3c4d72126633428ad25d053.svg";
export { ForwardRef as ReactComponent };